// src/components/gestionEvento/integraciones/fileUploadUtils.js

// --- Dependencias (si extractEventCodeFromName las necesita directamente) ---
// Si extractEventCodeFromName SÍ necesita acceso directo a estos arrays,
// tendrás que replantear cómo pasarle esos datos, ya que los utils
// no deberían usar hooks como useEventContext.
// Una opción es que la función que llama a extractEventCodeFromName
// (en EventManagerFiles) obtenga los códigos del contexto y los pase
// como argumento a extractEventCodeFromName.

// Ejemplo de CÓMO DEBERÍA SER extractEventCodeFromName en el utils:
const extractEventCodeFromName = (eventName, trackCodes, fieldHoriCodes, fieldVertCodes) => {
    if (!eventName) return '';
    const regex = /(\d+H|\d+S|\d+W|\d{2,4}(?!x\d+)|\d+[xX]\d+|[A-Z]{2}\d)/i;
    const match = eventName.match(regex);
    let code = match ? match[0].toUpperCase().replace('X','x') : '';
    // Usar los argumentos pasados
    if (code && (trackCodes.includes(code) || fieldHoriCodes.includes(code) || fieldVertCodes.includes(code))) {
        return code;
    }
    return '';
};


// --- Funciones de Parseo y Sanitización ---

const sanitizeText = (text) => {
    try {
        return text.replace(/Ã¡/g, 'á').replace(/Ã©/g, 'é').replace(/Ã­/g, 'í').replace(/Ã³/g, 'ó').replace(/Ãº/g, 'ú').replace(/Ã€/g, 'Á').replace(/Ã‰/g, 'É').replace(/Ã /g, 'Í').replace(/Ã“/g, 'Ó').replace(/Ãš/g, 'Ú').replace(/Ã±/g, 'ñ').replace(/Ã‘/g, 'Ñ').replace(/Âº/g, 'º').replace(/Âª/g, 'ª').replace(/Â¿/g, '¿').replace(/Â¡/g, '¡');
    } catch (e) {
        console.warn("Error sanitizando:", e);
        return text;
    }
};

const parseEvtFile = (content, trackCodes, fieldHoriCodes, fieldVertCodes) => { // Recibe códigos como argumento
    console.log("[EVT Parser] Iniciando parseo de .evt");
    const lines = content.split('\n').filter(line => line.trim() !== '');
    const events = [];
    let currentEvent = null;
    let lineCounter = 0;

    lines.forEach((line) => {
        lineCounter++;
        const sanitizedLine = sanitizeText(line.trim()); // Usa la función local
        if (sanitizedLine.startsWith(';')) return;
        if (/^\d/.test(sanitizedLine)) {
            const fields = sanitizedLine.split(','); if (fields.length < 4) return;
            const eventNumberStr = fields[0]?.trim(); const roundStr = fields[1]?.trim(); const heatStr = fields[2]?.trim(); const eventName = fields[3]?.trim() || 'Evento Sin Nombre';
            // Llama a extractEventCodeFromName local pasando los códigos
            let eventCode = (fields[9]?.trim() || fields[4]?.trim() || '').toUpperCase();
            if (!eventCode) eventCode = extractEventCodeFromName(eventName, trackCodes, fieldHoriCodes, fieldVertCodes);
            const numEvent = parseInt(eventNumberStr, 10); const numRound = parseInt(roundStr, 10); const numHeat = parseInt(heatStr, 10);
            if (isNaN(numEvent) || isNaN(numRound) || isNaN(numHeat)) return;
        currentEvent = {
       eventNumber: numEvent,
       round: numRound,
       heat: numHeat,
       eventName,
       eventCode,
       participants: []
     };
            events.push(currentEvent);
        } else if (sanitizedLine.startsWith(',')) {
           if (!currentEvent) return; const fields = sanitizedLine.split(','); if (fields.length < 6) return;
            const idNumber = fields[1]?.trim(); const lane = fields[2]?.trim() || ''; const lastName = fields[3]?.trim(); const firstName = fields[4]?.trim(); const affiliation = fields[5]?.trim();
            if (!idNumber || !lastName || !firstName || !affiliation) { console.warn(`[EVT Parser] Ln ${lineCounter}: Saltando participante, datos esenciales faltantes.`); return; }
            currentEvent.participants.push({ idNumber, lane, firstName, lastName, affiliation });
        } else { console.warn(`[EVT Parser] Ln ${lineCounter}: Formato desconocido: ${sanitizedLine}`); }
    });
    if (events.length === 0) throw new Error('No se encontraron eventos .evt válidos.');
    events.sort((a, b) => a.eventNumber - b.eventNumber || a.round - b.round || a.heat - b.heat);
    console.log(`[EVT Parser] .evt parseado: ${events.length} eventos.`);
    return events;
};

const parsePplFile = (content) => {
    console.log("[PPL Parser] Iniciando parseo de .ppl (Formato Hy-Tek)");
    const lines = content.split('\n').filter(line => line.trim() !== '');
    const athletes = [];
    let lineCounter = 0;
    const seenIds = new Set();

    lines.forEach((line) => {
      lineCounter++;
      const sanitizedLine = sanitizeText(line.trim()); // Usa sanitizeText local
      // ... (resto de la lógica de parsePplFile sin cambios) ...
         if (sanitizedLine.startsWith(';')) return;
         const fields = []; let currentField = ''; let inQuotes = false;
         for (let i = 0; i < sanitizedLine.length; i++) { const char = sanitizedLine[i]; if (char === '"' && (i === 0 || sanitizedLine[i-1] !== '\\')) { inQuotes = !inQuotes; } else if (char === ',' && !inQuotes) { fields.push(currentField.trim()); currentField = ''; } else { currentField += char; } } fields.push(currentField.trim());
         if (fields.length < 7) { console.warn(`[PPL Parser] Línea ${lineCounter}: Saltando atleta, formato inesperado o pocos campos: ${sanitizedLine}`); return; }
         const idNumber = fields[0]; const lastName = fields[1]; const firstName = fields[2]; const affiliation = fields[3]; const license = fields[4]; const genderCode = fields[5]; let eventNumbersRaw = fields[6];
         if (!idNumber) { console.warn(`[PPL Parser] Línea ${lineCounter}: Falta ID.`); return; } if (seenIds.has(idNumber)) { console.warn(`[PPL Parser] Línea ${lineCounter}: ID duplicado ${idNumber}.`); return; } if (!lastName || !firstName) { console.warn(`[PPL Parser] Línea ${lineCounter}: Falta Nombre/Apellido.`); return; } if (!affiliation) { console.warn(`[PPL Parser] Línea ${lineCounter}: Falta Afiliación.`); return; } if (genderCode !== 'M' && genderCode !== 'F') { console.warn(`[PPL Parser] Línea ${lineCounter}: Código de género inválido '${genderCode}'.`); }
         if (eventNumbersRaw.startsWith('"') && eventNumbersRaw.endsWith('"')) { eventNumbersRaw = eventNumbersRaw.substring(1, eventNumbersRaw.length - 1); }
         const eventNumbers = eventNumbersRaw.split(',').map(numStr => parseInt(numStr.trim(), 10)).filter(num => !isNaN(num));
         athletes.push({ idNumber: idNumber, firstName: firstName, lastName: lastName, affiliation: affiliation, license: license || '', gender: genderCode, registeredEvents: eventNumbers, }); seenIds.add(idNumber);
         // console.log(`[PPL Parser] Línea ${lineCounter}: Atleta ${idNumber} - ${firstName} ${lastName} (${genderCode}) Eventos: [${eventNumbers.join(',')}]`); // Comentado para reducir logs
    });

    if (athletes.length === 0) { throw new Error('No se encontraron atletas válidos en el archivo .ppl.'); }
    console.log(`[PPL Parser] Parseo de .ppl finalizado. ${athletes.length} atletas encontrados.`);
    return athletes;
};

const parseSchFile = (content) => {
    console.log("[SCH Parser] Iniciando parseo de .sch");
    const lines = content.split('\n').filter(l => l.trim() !== '');
    const schedules = [];
    let ln = 0;
    lines.forEach(line => {
        ln++;
        const sLine = sanitizeText(line.trim()); // Usa sanitizeText local
        if (sLine.startsWith(';')) return;
        const f = sLine.split(','); if (f.length < 3) return;
        const en = f[0]?.trim(); const ro = f[1]?.trim(); const he = f[2]?.trim(); const tod = f[3]?.trim() || '';
        const nE = parseInt(en, 10); const nR = parseInt(ro, 10); const nH = parseInt(he, 10);
        if (isNaN(nE) || isNaN(nR) || isNaN(nH)) return;
        schedules.push({ eventNumber: nE, round: nR, heat: nH, timeOfDay: tod });
    });
    if (schedules.length === 0) throw new Error('No se encontraron horarios .sch válidos.');
    console.log(`[SCH Parser] .sch parseado: ${schedules.length} horarios.`);
    return schedules;
};

// Exportar todas las funciones que se usarán externamente
export {
    sanitizeText,
    extractEventCodeFromName,
    parseEvtFile,
    parsePplFile,
    parseSchFile
};
